"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFinalForm = require("react-final-form");
var _components = require("@folio/stripes/components");
var _RefdataButtons = _interopRequireDefault(require("../../RefdataButtons"));
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditSettingValue = props => {
  const {
    currentSetting: setting,
    input,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    refdata,
    templates
  } = props;
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  const fieldLabel = kintIntl.formatKintMessage({
    id: 'settings.valueFor',
    overrideValue: labelOverrides?.valueFor
  }, {
    name: setting.key
  });

  // Adding default sort to refdata object in ascending order by label
  const sortByLabel = (a, b) => a.label.localeCompare(b.label);
  const sortedRefdata = refdata.sort(sortByLabel);
  switch (setting.settingType) {
    case 'Refdata':
      // Grab refdata values corresponding to setting
      // eslint-disable-next-line no-case-declarations
      let RefdataComponent = _components.Select;
      if (refdata.length > 0 && refdata.length <= 4) {
        RefdataComponent = _RefdataButtons.default;
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
        "aria-label": fieldLabel,
        component: RefdataComponent,
        dataOptions: sortedRefdata,
        name: `${input.name}.value`
      });
    case 'Password':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
        "aria-label": fieldLabel,
        autoFocus: true,
        component: _components.TextField,
        name: `${input.name}.value`,
        parse: v => v // Lets us send an empty string instead of 'undefined'
        ,
        type: "password"
      });
    case 'Template':
      {
        // Grab refdata values corresponding to setting
        // eslint-disable-next-line no-case-declarations
        const selectTemplateValues = [{
          value: '',
          label: ''
        }, ...templates.map(t => ({
          value: t.id,
          label: t.name
        }))];
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
          "aria-label": fieldLabel,
          component: _components.Select,
          dataOptions: selectTemplateValues,
          name: `${input.name}.value`,
          parse: v => v
        });
      }
    default:
      // If in doubt, go with String
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
        "aria-label": fieldLabel,
        autoFocus: true,
        component: _components.TextField,
        name: `${input.name}.value`,
        parse: v => v // Lets us send an empty string instead of 'undefined'
      });
  }
};
EditSettingValue.propTypes = {
  currentSetting: _propTypes.default.shape({
    settingType: _propTypes.default.string,
    key: _propTypes.default.string
  }),
  input: _propTypes.default.shape({
    name: _propTypes.default.string
  }),
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object,
  refdata: _propTypes.default.arrayOf(_propTypes.default.object),
  templates: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    id: _propTypes.default.string
  }))
};
var _default = exports.default = EditSettingValue;